import {useHistory,Link} from 'react-router-dom'
import React,{useEffect,useState} from 'react'
import {Spinner,Modal,Form,InputGroup,Toast,Popover,OverlayTrigger, Navbar, Container, Nav, Dropdown} from "react-bootstrap";
import {  Card,CardBody,Button, Row, Col,} from "reactstrap";
import { PencilSquare,Eye, Trash, CartCheck, GearFill, ArrowBarDown, Printer, Save2Fill, ArrowLeft, PlusCircleDotted, FileExcel, Files } from 'react-bootstrap-icons';
import {
  ButtonGroup,
  
} from "react-bootstrap";
import Axios from 'axios';
import {Typeahead} from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import dateformat from 'dateformat';
import Tables from '../../tableData'
import common from '../../commonData'

var dta = []
function ListeArticleHs() {

  const history = useHistory();
  const [validated, setValidated] = useState(false);
  const [datas,setDatas]=useState([])
  const [load,setLoad]=useState(false)
  const [show, setShow] = useState(false);
  const [codeart,setCodeart]=useState([])
  const [article,setArticle]=useState([])
  const [quantite,setQuantite]=useState(1)
  const [date,setDate]=useState("")
  const [motif,setMotif]=useState("")
  const [isSave,setIsSave]=useState(false)
  const [msgGravity,setMsgravity]=useState("success")
  const [msg,setMsg]=useState("")
  const [id,setId]=useState(0)
  const sidebarToggle = React.useRef();

 
  const openSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
    sidebarToggle.current.classList.toggle("toggled");
  };

  const handleClose = () => {
    setShow(false)
    setCodeart([])
  }
  const handleShow = () => {
    setShow(true);
    setCodeart([])
    setQuantite(1)
    setMotif("")
  }
  useEffect(()=>{
    setLoad(true)
    if (localStorage.getItem("user-info")) {
        (async function anyNameFunction() {
          await getArticle()
        })();
    }else{
      history.push("/login")
    }
  },[])

  function getArticle(){
    const getarticle = Axios.get(common.ipapi+'/api/article/indexall')
            const getArticlehs = Axios.get(common.ipapi+'/api/article/articlehs')
            Axios.all([getarticle,getArticlehs]).then(Axios.spread((...responses) => {
            setArticle(responses[0].data)
            setDatas(responses[1].data)
            dta = responses[1].data
            setLoad(false)
            })).catch(errors => {
            setLoad(false)
            })
  }
  const handleSubmit = (event) => {
    
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
        event.preventDefault();
        event.stopPropagation();
        setValidated(true);
    }else{
      saveDamag()
    }    
  };
  function saveDamag(e){
    setLoad(true)
    var url = ""
    var formData = new FormData();
    formData.append('codeart',codeart[0].id);
    formData.append('motif',motif);
    formData.append('date',date);
    formData.append('quantite',quantite);
    formData.append('user_id',common.userid);
    if(id !== 0){
        url=common.ipapi+"/api/article/updatehs/"+id
    }else{
        url=common.ipapi+"/api/article/storehs"
    }
    Axios({
      url: url,
      method:'POST',
      headers:{
        'Content-Type':'form-data'
      },data:formData})
    .then(res=>{
        setIsSave(true)
        setCodeart("")
        setMotif("")
        setQuantite(1)
        setShow(false)
        setMsgravity("info")
        setMsg(res.data.msg)
        setIsSave(true)
        setId(0)
        getArticle()
        setLoad(false)
        
    }).catch(error=>{
        setMsgravity("danger")
        setMsg(error)
        setIsSave(true)
        setLoad(false)
    }) 
}
  function  onDelete (id) {
    if(window.confirm("Voulez-vous supprimer cette ligne ?")){
      setLoad(true)
      Axios.delete(common.ipapi+'/api/article/destroyhs/'+id)
      .then(response=>{
        if(response.data.status==1){
          const del = dta.filter(d=>d.id !== id)
          dta=del
          setDatas(del)
          setLoad(false)
        }else{
         
        }
      })
    }
  }
  function IsModif(ids){
    setLoad(true)
    Axios.get(common.ipapi+'/api/article/ediths/'+ids)
        .then(response=>{
          setMotif(response.data.motif)
          setQuantite(response.data.quantite)
          setDate(response.data.dateope)
          setId(response.data.id)
          const t = []
            t.push({
              id:response.data.article.id,
              article_id: response.data.article.article_id,
              codeart: response.data.article.codeart,
              descriptionart:response.data.article.descriptionart,
              urlart: response.data.article.urlart,
              qteseuil: response.data.article.qteseuil,
              qtestock: response.data.article.qtestock,
              qtestockinit: response.data.article.qtestockinit,
              coeficient: response.data.article.coeficient,
              prixachat: response.data.article.prixachat,
              famille_id: response.data.article.famille_id,
              marque_id: response.data.article.marque_id,
              fournisseur_id: response.data.article.fournisseur_id,
              entrepot_id: response.data.article.entrepot_id,
              user_id: response.data.article.user_id,
              created_at: response.data.article.created_at,
              updated_at: response.data.article.updated_at
            })
          setCodeart(t)
          setShow(true)
          setLoad(false)
    })
  }
  

  const Images = ({ tableManager, value, field, data, column, colIndex, rowIndex }) => {
    return (
        <div>
            <Link to={`#/admin/article/fiche/${data.article.id}`}>{data.article.urlart ? data.article.urlart.indexOf('sortly') ==- 1 ? <img className="imgart rounded" src={common.ipapi+data.article.urlart}></img> : <img className='imgart rounded' src={data.article.urlart}></img>  : "" }</Link>
        </div>
    )
  }
  const Operation = ({ tableManager, value, field, data, column, colIndex, rowIndex }) => {
    return (
      <div className='menudrop'>
      <Dropdown>
        <Dropdown.Toggle variant="secondary" key="start" drop="start" id="dropdown-basic"></Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item href={`#/admin/article/fiche/${data.article_id}`}><Eye  size={25}  color='#000'/> Fiche article</Dropdown.Item>
          <Dropdown.Item href="#/admin/articles-hs" onClick={()=>IsModif(data.id)}  ><Files  size={20}  color='#000'/> Modifier</Dropdown.Item>
          <Dropdown.Item href="#/admin/articles-hs" onClick={()=>onDelete(data.id)} ><PencilSquare  size={20}  color='#000'/> Supprimer</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      </div>
    )
  }
  const CPrivente = ({ tableManager, value, field, data, column, colIndex, rowIndex }) => {
    return (
      new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'CFA' }).format(data.article.prixvente)
    )
  }
  const Perte = ({ tableManager, value, field, data, column, colIndex, rowIndex }) => {
    return (
      new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'CFA' }).format(data.article.prixvente*data.quantite)
    )
  }
  const dates = ({ tableManager, value, field, data, column, colIndex, rowIndex }) => {
    return (
      dateformat(data.created_at,"dd-mm-yyyy HH:MM")
    )
  }

  const fam = ({ tableManager, value, field, data, column, colIndex, rowIndex }) => {
    return (
      data.article.famille ? data.article.famille.libellefam : ""
    )
  }
  const marq = ({ tableManager, value, field, data, column, colIndex, rowIndex }) => {
    return (
      data.article.marque ? data.article.marque.libellemarq : ""
    )
  }
  const entr = ({ tableManager, value, field, data, column, colIndex, rowIndex }) => {
    return (
      data.article.entrepot ? data.article.entrepot.libelleentrepot : ""
    )
  }
  const descr = ({ tableManager, value, field, data, column, colIndex, rowIndex }) => {
    return (
      data.article.descriptionart
    )
  }
  const codearts = ({ tableManager, value, field, data, column, colIndex, rowIndex }) => {
    return (
      data.article.qrbarreshort
    )
  }
  
  const columns = [
    {
      id: 1,  
      label: 'Images',
      cellRenderer: Images,
      sortable: false,
      pinned: true,
      width: '40px',
      minResizeWidth: 40,
    },  
    {
        id: 2, 
        cellRenderer: codearts, 
        label: 'Code article',
        width: '110px'
    }, 
    {
        id: 3, 
        cellRenderer: descr,
        label: 'Descriptions',
    },
    {
        id: 4, 
        cellRenderer: fam, 
        label: 'Famille',
    },
    {
        id: 5, 
        cellRenderer: marq, 
        label: 'Models',
    },
    {
      id: 6, 
      cellRenderer: entr, 
      label: 'Entrepots',
    },
    {
      id: 7, 
      field: 'quantite', 
      label: 'Qté',
      width: '70px'
    },
    {
      id: 8, 
      field: 'article.prixachat', 
      label: 'Prix',
      width: '120px'
    },
    {
      id: 9,  
      label: 'P.vente.',
      field: 'prixvente',
      cellRenderer: CPrivente
    },
    {
      id: 10,  
      label: 'Perte',
      cellRenderer: Perte
    },
    {
      id: 11, 
      field: 'motif', 
      label: 'Motifs',
    },
    {
      id: 12, 
      field: 'created_at', 
      label: 'Crée le',
      cellRenderer: dates
    },
    {
      id: 13,  
      label: 'Actions',
      cellRenderer: Operation,
      pinned: true,
      sortable: false,
      width: '50px',
    },
  ];
 

  function saveAsExcel(){

  }
  function printListe(){

  }

    return (     
      <>
       <Toast id="toast" onClose={() => setIsSave(false)} show={isSave} delay={3000} bg={msgGravity} autohide>
              <Toast.Header>
                  <img
                    src="holder.js/20x20?text=%20"
                    className="rounded me-2"
                    alt=""
                  />
                  <strong className="me-auto">Info</strong>
              </Toast.Header>
              <Toast.Body>{msg}</Toast.Body>
          </Toast>
      <Modal show={load} size="sm" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Body>Veuillez patienter.......<Spinner animation="grow" variant="warning"/></Modal.Body>
      </Modal>
      <div className="content contents">
        <Navbar expand="lg" bg="light" variant="light">
          <Container>
            <Navbar.Brand href="#/admin/articles-hs">LISTE DES ARTICLES HS</Navbar.Brand>
            <Nav className="me-auto">
              <Nav.Link href="#/admin/articles-hs" onClick={handleShow} title='Ajouter un article endommagé'><PlusCircleDotted color="#ee1111" size={20}/> Créer</Nav.Link>
              <Nav.Link href="#/admin/articles-hs" onClick={() => saveAsExcel(datas)} title='Exporter vers excel'><FileExcel color="#0080ff" size={20}/> Excel</Nav.Link>
              <Nav.Link href="#/admin/articles-hs" onClick={() => printListe(datas)} title='Exporter vers pdf'><Printer color="#0080ff" size={20}/> Imprimer</Nav.Link>
            </Nav>
          </Container>
        </Navbar>
      {/* <Card>

      <Form className="ml-auto">
          <ButtonGroup size="sm">
            <Button onClick={handleShow}><a href="#/admin/articles-hs"><CartCheck color="#807f7e" size={20}/> Ajouter</a></Button>
            <Button><a href="#/admin/articles-hs"><Printer color="#807f7e" size={20}/> Imprimer</a></Button>
          </ButtonGroup>
          </Form>
        </Card> */}
        <Row>
          <Col md="12">
         

        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Ajouter un article HS</Modal.Title>
          </Modal.Header>
          
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Modal.Body>
                      <Form.Group as={Col} md="12" controlId="validationCustomUsername">
                      <InputGroup hasValidation>
                          {/* <InputGroup.Text id="inputGroupPrepend">Code article:</InputGroup.Text> */}
                          <Typeahead
                          id="my-typeahead-id" 
                          labelKey={option => `${option.qrbarre} / ${option.descriptionart} / qte (${option.qtestock})`}
                          filterBy={["codeart", "qrbarre", "sortlysid"]}
                          selected={codeart}
                          options={article}
                          multiple
                          onChange={(codeart)=>setCodeart(codeart)}
                      />
                          <Form.Control.Feedback type="invalid">
                          Veuillez saisir le code article
                          </Form.Control.Feedback>
                      </InputGroup>
                      </Form.Group><br/>
                      <Form.Group as={Col} md="12" controlId='qte'>
                          <InputGroup hasValidation>
                              <InputGroup.Text id="inputGroupPrepend">Qté HS:</InputGroup.Text>
                                  <Form.Control
                                      type="number"
                                      placeholder="Quantité HS"
                                      aria-describedby="inputGroupPrepend"
                                      required
                                      size="sm"
                                      min={1}
                                      value={quantite}
                                      onChange={(e)=>setQuantite(e.target.value)}
                                  />
                              <Form.Control.Feedback type="invalid">
                                  Veuillez saisir la quantité article.
                              </Form.Control.Feedback>
                          </InputGroup>
                      </Form.Group><br/>
                      <Form.Group as={Col} md="12" controlId="validationCustomUsername">
                          <InputGroup hasValidation>
                          <InputGroup.Text id="inputGroupPrepend">Date entrées:</InputGroup.Text>
                          <Form.Control
                              type="date"
                              placeholder="Date entrées"
                              aria-describedby="inputGroupPrepend"
                              required
                              size="sm"
                              value={date}
                              onChange={(e)=>setDate(e.target.value)}
                          />
                          <Form.Control.Feedback type="invalid">
                          Veuillez saisir la date
                          </Form.Control.Feedback>
                          </InputGroup>
                      </Form.Group><br/>
                      <Form.Group as={Col} md="12" controlId='qte'>
                          <InputGroup hasValidation>
                              <InputGroup.Text id="inputGroupPrepend">Motif:</InputGroup.Text>
                                  <Form.Control
                                      type="text"
                                      placeholder="Motif"
                                      aria-describedby="inputGroupPrepend"
                                      required
                                      size="sm"
                                      rows={3} 
                                      min="1"
                                      value={motif}
                                      onChange={(e)=>setMotif(e.target.value)}
                                  />
                              <Form.Control.Feedback type="invalid">
                                  Veuillez saisir la quantité article.
                              </Form.Control.Feedback>
                          </InputGroup>
                      </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                  <Button type="reset" variant="ligth" onClick={handleClose}><ArrowLeft color="red" size={20}/> Annuler</Button>
                  <Button type="submit" variant="ligth"><Save2Fill color="orange" size={20}/> Enregister</Button>
              </Modal.Footer>
          </Form>
        </Modal>
        <Tables columns={columns} rows={datas} isLoading={load}/>
      </Col>
        </Row>
        </div>
  </>
    );
  }
  
  export default ListeArticleHs;